module.exports = __webpack_public_path__ + "f3ec5fdbfc3533249eef86918cc3f485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/bg_3.jpg
// module id = 244
// module chunks = 1